import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=52a5461e&scoped=true&"
import script from "./ShippingAddress.vue?vue&type=script&lang=js&"
export * from "./ShippingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddress.vue?vue&type=style&index=0&id=52a5461e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5461e",
  null
  
)

export default component.exports